import { useEffect, useState } from "react";
import Videos from "../../page/videos/Videos";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";

const VideosController = () => {
  const [showModal, setShowModal] = useState(false);
  const [videoToEdit, setVideoToEdit] = useState(null);
  const [videos, setVideos] = useState(null);
  const [provincias, setProvincias] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    per_page: 50,
    ["filter[status]"]: "ACTIVO",
    sort: "-id",
  });
  const [form, setForm] = useState({
    titulo: "",
    descripcion: "",
    content: "",
    url: "",
    imagen: "",
    provincia: "",
    status: "",
  });
  let controller;

  const fetch = async (setData, params, url, signal, loading) => {
    try {
      const response = await apiPrivateAntesala.get(url, {
        params,
        signal,
      });
      if (response.status == 201 || response.status == 200) {
        setData(response.data);
        if (loading) {
          loading(false);
        }
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Request aborted");
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "guardar":
        {
          if (videoToEdit) {
            let formData = new FormData();

            /*Evento*/
            formData.append("_method", "PUT");
            formData.append("titulo", value.titulo);
            formData.append("descripcion", value.descripcion);
            if (value.imagen) formData.append("imagen", value.imagen);
            formData.append("content", value.content);
            formData.append("url", value.url);
            formData.append("provincia", value.provincia);

            const response = await RestPrivateAntesala({
              url: `/videos/${videoToEdit.id}`,
              formData: formData,
              method: "post",
              setLoading: setLoading,
            });

            //Error
            if (response.status == 201 || response.status == 200) {
              setVideoToEdit(null);
              setShowModal(false);
              return Alerts({
                msg: "Alert",
                title: "Video actualizado con exito",
                code: "200",
                type: "success",
              });
            } else {
              if (typeof response.data.msg === "string") {
                return Alerts({
                  msg: "Alert",
                  title: response.data.msg,
                  code: "404",
                  type: "error",
                });
              }

              Object.keys(response.data.msg).map((key) => {
                return Alerts({
                  msg: "Alert",
                  title: response.data.msg[key][0],
                  code: "401",
                  type: "error",
                });
              });
            }
          } else {
            let formData = new FormData();

            /*Evento*/
            formData.append("titulo", value.titulo);
            formData.append("descripcion", value.descripcion);
            if (value.imagen) formData.append("imagen", value.imagen);
            formData.append("content", value.content);
            formData.append("url", value.url);
            formData.append("provincia", value.provincia);
            formData.append("status", "ACTIVO");

            const response = await RestPrivateAntesala({
              url: `/videos`,
              formData: formData,
              method: "post",
              setLoading: setLoading,
            });

            //Error
            if (response.status == 201 || response.status == 200) {
              return Alerts({
                msg: "Alert",
                title: "Video creado con exito",
                code: "200",
                type: "success",
              });
            } else {
              if (typeof response.data.msg === "string") {
                return Alerts({
                  msg: "Alert",
                  title: response.data.msg,
                  code: "401",
                  type: "error",
                });
              }

              Object.keys(response.data.msg).map((key) => {
                return Alerts({
                  msg: "Alert",
                  title: response.data.msg[key][0],
                  code: "401",
                  type: "error",
                });
              });
            }
          }
        }
        break;
      case "editar":
        {
        }
        break;
    }
  };

  const onChange = (e, value) => {
    switch (e.target.name) {
      case "search":
        {
          if (controller) controller.abort();

          controller = new AbortController();
          const signal = AbortController.signal;

          let params = {
            ...filter,
            ["filter[title]"]: e.target.value,
          };

          setFilter({ ...params });

          return fetch(setVideos, params, "/videos", signal);
        }
        break;
    }
  };

  useEffect(() => {
    if (!provincias) {
      fetch(setProvincias, {}, "/provincias");
    }
  }, []);

  useEffect(() => {
    if (!videos) {
      setLoading(true);
      let params = {
        ...filter,
      };

      fetch(setVideos, params, "/videos", null, setLoading);
    }
  }, []);
  return (
    <Videos
      fetch={fetch}
      setFilter={setFilter}
      filter={filter}
      setData={setVideos}
      data={videos ?? { data: [], links: [] }}
      onClick={onClick}
      onChange={onChange}
      loading={loading}
      setLoading={setLoading}
      provincias={provincias}
      setShowModal={setShowModal}
      setVideoToEdit={setVideoToEdit}
      showModal={showModal}
      videoToEdit={videoToEdit}
    />
  );
};

export default VideosController;
